// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3QwAt","logo":"header-module--logo--U17LV"};